var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagPapuaNewGuinea(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_16245)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.3137 27.3137C21.0654 33.5621 10.9347 33.5621 4.68624 27.3137C-1.56213 21.0653 -1.56213 10.9346 4.68631 4.68618C10.9347 -1.56219 20.0815 -0.578378 26.3299 5.67006C32.5782 11.9184 33.5621 21.0653 27.3137 27.3137Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.68631 4.68623C10.9347 -1.56215 21.0652 -1.56202 27.3137 4.68629C33.5621 10.9347 33.5621 21.0653 27.3137 27.3137",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2281 21.5652L12.4871 22.3624H13.3253L12.6472 22.855L12.9062 23.6522L12.2281 23.1595L11.55 23.6522L11.809 22.855L11.1309 22.3624H11.969L12.2281 21.5652Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0865 13.9131L10.5183 15.2417H11.9152L10.785 16.0628L11.2167 17.3914L10.0865 16.5702L8.95637 17.3914L9.38812 16.0628L8.25787 15.2417H9.65487L10.0865 13.9131Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0865 23.6523L10.5182 24.981H11.9152L10.7849 25.802L11.2167 27.1306L10.0865 26.3094L8.95637 27.1306L9.388 25.802L8.25787 24.981H9.65469L10.0865 23.6523Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1713 17.3914L14.6031 18.72H16L14.8698 19.541L15.3015 20.8696L14.1713 20.0484L13.0412 20.8696L13.473 19.541L12.3428 18.72H13.7397L14.1713 17.3914Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.00251 17.3914L6.43433 18.72H7.83114L6.70101 19.541L7.13264 20.8696L6.00251 20.0484L4.87233 20.8696L5.30414 19.541L4.17389 18.72H5.57083L6.00251 17.3914Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7838 11.8475C26.0688 11.1324 25.1397 10.71 24.1412 10.6374L27.13 8.31288C25.9397 7.12257 24.3443 6.585 22.7875 6.69869C22.6012 6.02894 22.2458 5.39632 21.7192 4.86963L20.5386 7.23075C20.4612 7.08963 20.3631 6.95682 20.2435 6.83725C19.5642 6.15807 18.4631 6.15807 17.784 6.83725C17.1048 7.51644 17.1047 8.61757 17.784 9.29675C17.9035 9.41632 18.0364 9.51438 18.1775 9.59188L15.8164 10.7724C16.3432 11.2993 16.9763 11.6549 17.6464 11.8411C17.5323 13.3979 18.0693 14.993 19.2597 16.1834L21.871 12.826C22.0674 12.6326 22.3268 12.5258 22.6028 12.5258C22.8816 12.5258 23.1436 12.6343 23.3407 12.8314C23.5378 13.0285 23.6463 13.2906 23.6463 13.5693C23.6463 13.848 23.5378 14.11 23.3407 14.3071L24.3245 15.291C24.7843 14.8311 25.0377 14.2197 25.0377 13.5693C25.0377 13.0372 24.8679 12.5313 24.5545 12.1131C25.0112 12.235 25.4427 12.4739 25.8002 12.8314C26.8852 13.9164 26.8852 15.6818 25.8002 16.7666L26.7841 17.7505C27.5724 16.9621 28.0066 15.914 28.0066 14.7991C28.0064 13.684 27.5722 12.6359 26.7838 11.8475Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_16245"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagPapuaNewGuinea);
export default __webpack_public_path__ + "static/media/flag_papua_new_guinea.6c93df4986b69c3ccc6d2867e6fc30e0.svg";
export { ForwardRef as ReactComponent };